(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-start-slideshow"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("load", function (e) {

const body = document.querySelector(".index-page");

if (body) {
		startAnimation(body);
	}
const speed = document.querySelector('.swiper').dataset.speed ? document.querySelector('.swiper').dataset.speed : 5;
const duration = document.querySelector('.swiper').dataset.duration ? document.querySelector('.swiper').dataset.duration : 500;
const swiper = new Swiper('.loaded .swiper__home-slideshow', {
    speed: speed,
    spaceBetween: 0,
    slidesPerView: 1,
	 centeredSlides: true,
	 loop: true,
     
	 autoplay: {
   	delay: duration,
 	},
  });

function loadWindow(home) {
	home.classList.add("loaded");
}
swiper.on("click", function(e){
	body.classList.add('transition')
	const headerLink = document.querySelector('.header__heading-link--bottom');
  const headerBtn = document.querySelector('.header__menu-drawer-btn');
  console.log('clicked header link', e);
	headerBtn.addEventListener("transitionend", function (e) {
    console.log('clicked header btn');
	});

})

function startAnimation(body) {
	loadWindow(body);
}

})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${
        this.header.offsetHeight
      }px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      


      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        


        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  window.addEventListener('DOMContentLoaded', () => {
    if(window.innerWidth > 991.98) {
      document.querySelector('.page__wrapper').prepend(document.querySelector('.header-icons'));
    } else {
      document.querySelector('header.header').append(document.querySelector('.header-icons'));
    }
    document.querySelector('.header__menu-drawer-btn').addEventListener('click', () => {
      const menuContainer = document.querySelector('.header__menu-container');
      if(menuContainer.classList.contains('is-open')) {
        menuContainer.classList.remove('is-open');
      } else {
        menuContainer.classList.add('is-open');
      }
    });
    document.querySelector('.header__menu-modal-container').addEventListener('click', (event) => {
      if(event.target.classList.contains('header__menu-modal-container')) {
        document.querySelector('.header__menu-container').classList.remove('is-open');
      }
    });
  });
  window.addEventListener('resize', () => {
    const headerIcons = document.querySelector('.header-icons');
    if(window.innerWidth > 991.98) {
      document.querySelector('.page__wrapper').prepend(headerIcons);
    } else {
      document.querySelector('header.header').append(headerIcons);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    const swiper = new Swiper('.product-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 10,
      // Optional parameters
      direction: 'horizontal',
      mousewheel: {
        releaseOnEdges: true,
      },
      loop: false,
      breakpoints: {
        // when window width is >= 320px
        //  320: {
        //    slidesPerView: 1,
        //    spaceBetween: 10,
        // 	autoHeight: true
        //  },
        // when window width is >= 480px
        320: {
          slidesPerView: 'auto',
          spaceBetween: 10,
        },
      },
    });

    function slideToActiveSlide() {
      document.addEventListener('click', function (e) {
        if (e.target.tagName === 'INPUT' && e.target.closest('.product-form__input')) {
          const swiperBlock = document.querySelector('.swiper');
          if (swiperBlock) {
            setTimeout(() => {
              const activeSlideIndex = swiperBlock.dataset.activeIndex;
              if (activeSlideIndex) {
                const currentSlideID = document.querySelector('li[data-media-id]').dataset.mediaId;
                const currentSlide = document.querySelector('li[data-media-id]');
                const allSlides = document.querySelectorAll('li[data-media-id]');
                swiper.slideTo(Array.from(allSlides).indexOf(currentSlide), 500, true);
              }
            }, 10);
          }
        }
      });
    }
    window.onload = () => {
      slideToActiveSlide();
    };
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommendations-product"]) return;
  try {
    
	 var loadProductRecommendationsIntoSection = function() {
		// Look for an element with class 'product-recommendations'
		var productRecommendationsSection = document.querySelector(".product-recommendations");
		if (productRecommendationsSection === null) { return; }
		// Read product id from data attribute
		var productId = productRecommendationsSection.dataset.productId;
		// Read limit from data attribute
		var limit = productRecommendationsSection.dataset.limit;
		// Build request URL
		var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
		// Create request and submit it using Ajax
		var request = new XMLHttpRequest();
		request.open("GET", requestUrl);
		request.onload = function() {
		  if (request.status >= 200 && request.status < 300) {
			 var container = document.createElement("div");
			 container.innerHTML = request.response;
			 productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
		  }
		};
		request.send();
	 };
	 // If your section has theme settings, the theme editor
	 // reloads the section as you edit those settings. When that happens, the
	 // recommendations need to be fetched again.
	 // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
	 document.addEventListener("shopify:section:load", function(event) {
		if (event.detail.sectionId === "product-recommendations") {
		  loadProductRecommendationsIntoSection();
		}
	 });
	 // Fetching the recommendations on page load
	 loadProductRecommendationsIntoSection();
	 
  } catch(e) { console.error(e); }
})();
})();
